import {
  PluginChatsPage,
  useRefetchEmailThreadJobs,
} from '@shared/plugin/pages/Chats';

export function GmailChatsPage() {
  const refetchEmailThreadJobs = useRefetchEmailThreadJobs();
  return (
    <PluginChatsPage
      onNewMessageInSelectedConversation={refetchEmailThreadJobs}
    />
  );
}
